import React, { useState } from "react";
import "./AgentRules.scss";

const AgentFees = () => {
  const allRules = [
    { id: "regional_plan", name: "Regional Plan" },
    { id: "country_plan", name: "Country Plan" },
    {
      id: "education_plan",
      name: "Education Plan",
    },
  ];

  const [rules, setRules] = useState([
    {
      id: "education_plan",
      name: "Education Plan",
    },
  ]);
  const [selectedRuleId, setSelectedRuleId] = useState("");

  const handleAddRule = () => {
    const ruleToAdd = allRules.find((rule) => rule.id === selectedRuleId);
    if (ruleToAdd && !rules.find((rule) => rule.id === ruleToAdd.id)) {
      setRules([...rules, ruleToAdd]);
    }
  };

  const handleDeleteRule = (ruleId) => {
    setRules(rules.filter((rule) => rule.id !== ruleId));
  };

  const availableOptions = allRules.filter(
    (option) => !rules.find((rule) => rule.id === option.id)
  );

  return (
    <div className="agent-rules-container">
      <div>
        <div>
          <label for="time" class="selector-titles">
            Plan
          </label>
        </div>
        <div class="transaction-selector">
          <select
            value={selectedRuleId}
            onChange={(e) => setSelectedRuleId(e.target.value)}
          >
            <option value="">Select a plan</option>
            {availableOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
          <button onClick={handleAddRule}>Add Plan</button>
        </div>
      </div>
      <table className="full-width-table-rules">
        <thead>
          <tr className="header-row">
            <th>Fee Plan</th>
            <th className="table-date-header">Status</th>
            <th className="table-date-header"> Action</th>
          </tr>
        </thead>
        <tbody>
          {rules.map((rule) => (
            <tr key={rule.id}>
              <td>{rule.name}</td>
              <td>
                <p className="enabled-rule">Enabled</p>
              </td>
              <td>
                <button onClick={() => handleDeleteRule(rule.id)}>
                  DELETE
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AgentFees;
